import { BulkActionsBar, type BulkActionsBarProps } from './src/BulkActionsBar';
export { BulkActionsBar, type BulkActionsBarProps };

// TODO(v6): Remove in v6
/**
 * @deprecated TableSelectionActionBar is renamed to BulkActionsBar. Please use BulkActionsBar instead.
 */
export const TableSelectionActionBar = BulkActionsBar;
/**
 * @deprecated TableSelectionActionBar is renamed to BulkActionsBar. Please use BulkActionsBarProps instead.
 */
export type TableSelectionActionBarProps = BulkActionsBarProps;
